import React, { createContext } from 'react';
import { SelectedParticipantProvider, } from '../../../../src/components/VideoProvider/useSelectedParticipant/useSelectedParticipant';
import AttachVisibilityHandler from '../../../../src/components/VideoProvider/AttachVisibilityHandler/AttachVisibilityHandler';
import useHandleRoomDisconnectionErrors from '../../../../src/components/VideoProvider/useHandleRoomDisconnectionErrors/useHandleRoomDisconnectionErrors';
import useHandleOnDisconnect from '../../../../src/components/VideoProvider/useHandleOnDisconnect/useHandleOnDisconnect';
import useHandleTrackPublicationFailed from '../../../../src/components/VideoProvider/useHandleTrackPublicationFailed/useHandleTrackPublicationFailed';
import useLocalTracks from './useLocalTracks/useLocalTracks';
import useRoom from '../../../../src/components/VideoProvider/useRoom/useRoom';
import useChatLog from './useChatLog/useChatLog';
import DatatrackProvider from './DatatrackProvider';
export const VideoContext = createContext(null);
export function VideoProvider({ options, children, onError = () => { }, onDisconnect = () => { }, }) {
    const onErrorCallback = (error) => {
        console.error(`ERROR: ${error.message}`, error);
        onError(error);
    };
    const { localTracks, getLocalVideoTrack, getLocalAudioTrack, getLocalDataTrack, isAcquiringLocalTracks, removeLocalVideoTrack, removeLocalAudioTrack, videoDeviceOptions, setVideoDeviceOptions, gumExceptionState, videoAccessState, audioAccessState, } = useLocalTracks();
    const { chatLog, addChatMsg, chatVisible, setChatVisible, toggleChatVis, unreadMsgCount, setUnreadMsgCount, } = useChatLog();
    const { room, isConnecting, connect } = useRoom(localTracks, onErrorCallback, options);
    // Register onError and onDisconnect callback functions.
    useHandleRoomDisconnectionErrors(room, onError);
    useHandleTrackPublicationFailed(room, onError);
    useHandleOnDisconnect(room, onDisconnect);
    return (React.createElement(VideoContext.Provider, { value: {
            room,
            chatLog,
            addChatMsg,
            chatVisible,
            setChatVisible,
            toggleChatVis,
            unreadMsgCount,
            setUnreadMsgCount,
            localTracks,
            isConnecting,
            onError: onErrorCallback,
            onDisconnect,
            getLocalVideoTrack,
            getLocalAudioTrack,
            getLocalDataTrack,
            connect,
            isAcquiringLocalTracks,
            removeLocalVideoTrack,
            removeLocalAudioTrack,
            videoDeviceOptions,
            setVideoDeviceOptions,
            gumExceptionState,
            videoAccessState,
            audioAccessState,
        } },
        React.createElement(DatatrackProvider, null,
            React.createElement(SelectedParticipantProvider, { room: room }, children),
            React.createElement(AttachVisibilityHandler, null))));
}
//# sourceMappingURL=index.js.map